import mixins from "../../mixins";

const generateUID = mixins.generateUID.methods.generateUID;

export default {
  isEditMode: true,
  pageProperties: {
    "pages": [
      {
        "pageName": "home",
        "pageId": 1,
        "sections": [
          {
            "sectionId": "a0us1n",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "fields": [
              {
                fieldId: "vas2fp",
                fieldType: "multi-campaign"
              }
            ]
          }
        ]
      },
      { // ProtexCarrefour campaign
        "pageName": "ProtexCarrefour",
        "pageId": 28972,
        "isPublic": true,
        "sections": [
          {
            "sectionId": "orbg8s",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "fields": [
              {
                "fieldType": "refresh-token",
                "fieldId": "ij3433"
              },
              {
                fieldId: "dte-003",
                fieldType: "dataLayer-event",
                properties: {
                  eventName: "PageView",
                  fbEvent: "PageView"
                }
              },
              {
                "fieldType": "key-visual",
                "fieldId": "296eg1",
                "properties": {
                  "grid": {
                    "columns": "12"
                  },
                  "styles": {
                    "padding": "0"
                  },
                  "noContainer": false,
                  "addRow": true,
                  "desktopImageUrl": "/assets/campaigns/ProtexCarrefour/key-visual.png",
                  "mobileImageUrl": "/assets/campaigns/ProtexCarrefour/key-visual.png"
                }
              },
              {
                "fieldType": "participa",
                "fieldId": "acsh315",
                "properties": {
                  "grid": {
                    "columns": "12"
                  },
                  "color": "#f2ac29",
                  "buttonClass": "",
                  "nextPage": "ProtexCarrefour/InscrieBonul",
                  "campaign": "ProtexCarrefour",
                  "steps": [
                    {
                      "title": "Pasul 1",
                      "text": "Incarca bonul",
                      "image": "factura"
                    },
                    {
                      "title": "Pasul 2",
                      "text": "Inregistreaza-te",
                      "image": "register"
                    }
                  ]
                }
              },
              {
                "fieldType": "key-visual",
                "fieldId": "vanbd",
                "properties": {
                  "grid": {
                    "columns": "12"
                  },
                  "addClass": "trademark_visual",
                  "noContainer": false,
                  "addRow": true,
                  "desktopImageUrl": "/assets/campaigns/ProtexCarrefour/trademark.png",
                  "mobileImageUrl": "/assets/campaigns/ProtexCarrefour/trademark.png"
                }
              }
            ]
          }
        ]
      },
      {
        "pageName": "ProtexCarrefour/InscrieBonul",
        "pageId": 22345,
        "sections": [
          {
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "sectionId": "fu30zq",
            "fields": [
              {
                "fieldType": "step-counter",
                "fieldId": "tj4j49",
                "properties": {
                  "activeIndex": 0,
                  "colorSchema": "#f3b238",
                  "stepShadow": "rgba(242, 172, 41, 0.26)",
                  "startGradient": "linear-gradient(to right, rgba(242, 172, 41, 1) 0% 50%, rgba(242, 172, 41, 0.3) 50% 100%)",
                  "endGradient": "linear-gradient(to right, rgba(242, 172, 41, 1) 0% 100%)",
                  "completedGradient": "linear-gradient(242.76deg, #f5be57 12.67%, #e89a0d 83.65%), #ffffff",
                  "steps": [
                    {
                      "title": "Incarca bonul fiscal/factura",
                      "page": "ProtexCarrefour/InscrieBonul"
                    },
                    {
                      "title": "Inregistreaza-te",
                      "page": "ProtexCarrefour/Inregistreaza"
                    }
                  ]
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "<h1>Incarca bonul fiscal/factura</h1>"
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "La acest pas, te rugam sa incarci dovada achizitionarii produselor Protex",
                  "grid": {
                    "marginTop": "15px",
                    "marginBottom": "30px"
                  },
                  styles: {
                    "font-weight": '500;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '20px;',
                    "color": "#0F2967;"
                  }
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "basg325",
                "properties": {
                  "text": "Te rugam sa faci o poza a intregului/intregii bon fiscal/facturi sau sa incarci un PDF al facturii",
                  "grid": {
                    "marginBottom": "40px"
                  },
                  styles: {
                    "font-weight": '400;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '14px;',
                    "line-height": "20px;",
                    "color": "#0F2967;"
                  }
                }
              }
            ]
          },
          {
            "sectionId": "dyx8uv",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 0,
                    "justifyContent": "center",
                    "maxWidth": "1230px"
                  },
                  "fields": [
                    {
                      "fieldType": "receipt-processor",
                      "fieldId": "klvakj",
                      "properties": {
                        texts: {
                          choose: 'Selecteaza un fisier',
                          receiptUpload: '<span style="font-size:18px; font-weight: 500;font-family:Plus Jakarta Sans">Apasa aici pentru a incarca bonul fiscal/factura.</span>.<br> Doar fisierele JPEG, PNG si PDF sunt acceptate.<br> Maxim 16 MB.',
                          wrongFormat: 'Acest format nu este suportat. Doar fisiere jpeg, png sau pdf sunt acceptate.',
                          fileSizeLimit: 'Fisierul este prea mare. Acesta nu poate avea mai mult de 16 MB.'
                        },
                        "colorSchema": "#f3b238",
                        "fileUploadColor": "rgba(0, 0, 0, 0.5)",
                        "borderColor": "#7997e1",
                        "buttonClass": "btn-yellow",
                        "grid": {
                          "columns": 5,
                          "alignItems": "center",
                          "justifyContent": "center"
                        },
                        "successAction": {
                          "fn": "goToPage",
                          "params": "ProtexCarrefour/Inregistreaza"
                        },
                        "campaignId": "colgate-palmolive",
                        "phrases": [
                          "Chitanta dvs. este acum incarcata si procesata.",
                          "Chitanta va fi procesata automat. Aceasta poate dura un minut. Va rugam sa aveti rabdare.",
                          "Daca primiti un mesaj de eroare, luati o versiune mai buna a chitantei si incarcati-o din nou."
                        ],
                        "cornerDetectionPhrases": [
                          "Te rugam sa ajustezi dreptunghiul gri pentru a incadra bonul.",
                          "Te rugam sa potrivesti bonul in cadran.",
                          "Puteti sterge informatii private cu instrumentul de stergere."
                        ],
                        "eraseColor": "#ffffff",
                        "eraseSize": 12,
                        "cropColor": "#F3B034",
                        "cropBackground": "rgba(0,0,0,0.6)",
                        "cropTitle": "Decupeaza",
                        "eraseTitle": "Acopera",
                        "dragTitle": "Deplaseaza imaginea",
                        "zoomInTitle": "Mareste",
                        "zoomOutTitle": "Micsoreaza",
                        "selectImageTitle": "Select an Image",
                        "selectAnotherTitle": "Select Another",
                        "controlsBackground": "#4193d3",
                        "backgroundColorBtn": "black"
                      }
                    },
                    {
                      "fieldType": "empty-bucket",
                      "properties": {
                        "grid": {
                          "columns": 7
                        },
                        "fields": [
                          {
                            "fieldType": "receipt-information",
                            "fieldId": "5mq1p6",
                            "properties": {
                              "grid": {
                                "alignItems": "center",
                                "justifyContent": "center",
                                "columns": "12"
                              },
                              "styles": {
                                "text-align": "left"
                              },
                              "color": "#f2ac29",
                              "descriptionText": "Te rugam sa faci o poza a bonului fiscal/facturii. Urmatoarele informatii trebuie sa fie vizibile:",
                              "receiptImage": "receipt",
                              "steps": [
                                {
                                  "text": "Nume magazin",
                                  "label": "A"
                                },
                                {
                                  "text": "Produsele participante la promotie si pretul lor",
                                  "label": "B"
                                },
                                {
                                  "text": "Suma totala a bonului fiscal/facturii in LEI",
                                  "label": "C"
                                },
                                {
                                  "text": "Nr. bonului fiscal/facturii",
                                  "label": "D"
                                },
                                {
                                  "text": "Data si ora de pe bonul fiscal sau factura",
                                  "label": "E"
                                }
                              ]
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            "sectionId": "bsbsd35",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "receipt-image-information"
              }
            ]
          },
          {
            "sectionId": "hmgwhl",
            "grid": {
              "columns": 12,
              "display": "flex",
              "alignItems": "center",
              "position": "relative",
              "paddingTop": "60px",
              "paddingBottom": "40px"
            },
            "container": true,
            "buttonsWrap": true,
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "16tzm1",
                "properties": {
                  "grid": {
                    "columns": "0"
                  },
                  "addClass": "btn-link",
                  "text": "Inapoi",
                  "disabled": false,
                  "styles": {
                    "position": "absolute;",
                    "left": 0
                  },
                  "action": {
                    "fn": "goToPage",
                    "params": "ProtexCarrefour"
                  }
                }
              },
              {
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": "0",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "text": "Continua",
                  "shouldCheckCrop": true,
                  "requires": ["klvakj"],
                  "action": {
                    "fn": "sendReceipt",
                    "params": ""
                  }
                }
              }
            ]
          }
        ]
      },
      {
        "pageName": "ProtexCarrefour/Inregistreaza",
        "pageId": 634553232,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 12
            },
            "container": true,
            "fields": [
              {
                "fieldType": "step-counter",
                "fieldId": "6gx3um",
                "properties": {
                  "activeIndex": 1,
                  "colorSchema": "#f3b238",
                  "stepShadow": "rgba(242, 172, 41, 0.26)",
                  "startGradient": "linear-gradient(to right, rgba(242, 172, 41, 1) 0% 50%, rgba(242, 172, 41, 0.3) 50% 100%)",
                  "endGradient": "linear-gradient(to right, rgba(242, 172, 41, 1) 0% 100%)",
                  "completedGradient": "linear-gradient(242.76deg, #f5be57 12.67%, #e89a0d 83.65%), #ffffff",
                  "steps": [
                    {
                      "title": "Incarca bonul fiscal/factura",
                      "page": "ProtexCarrefour/InscrieBonul",
                      "srcimage": "/assets/icons/step3.svg"
                    },
                    {
                      "title": "Inregistreaza-te",
                      "page": "ProtexCarrefour/Inregistreaza",
                      "srcimage": "/assets/icons/step2.svg"
                    }
                  ]
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "fckzg7",
                "properties": {
                  "text": "<h1>Formular de inscriere</h1>"
                }
              }
            ]
          },
          {
            "sectionId": "ci88zt",
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 4,
              "marginTop": "40px"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "form-component",
                "fieldId": "j765n4b",
                "properties": {
                  "styles": {
                    "margin": "0",
                    "justifyContent": "center",
                    "--maxWidth": "545px",
                    "--backgroundColor": "#fbfcfe"
                  },
                  "grid": {
                    "alignItems": "center",
                    "columns": "0",
                    "justifyContent": "center"
                  },
                  "requires": [
                    "1"
                  ],
                  "successAction": {
                    "fn": "goToPage",
                    "params": "ProtexCarrefour/Multumim"
                  },
                  "endpoint": "/register",
                  "fields": [
                    {
                      "fieldId": "b4baqs",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "surname",
                        "autocomplete": "no",
                        "label": "Prenume",
                        "placeholder": "",
                        "text": "",
                        "color": "#0F2967",
                        "validation": "required|onlyLetters",
                        "grid": {
                          "alignItems": "center",
                          "justifyContent": "center",
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "30px"
                        }
                      }
                    },
                    {
                      "fieldId": "gofije",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "name",
                        "autocomplete": "no",
                        "label": "Nume",
                        "placeholder": "",
                        "text": "",
                        "color": "#0F2967",
                        "validation": "required|onlyLetters",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px"
                        }
                      }
                    },
                    {
                      "fieldId": "h7kzf9",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "email",
                        "label": "E-mail",
                        "placeholder": "",
                        "text": "",
                        "color": "#0F2967",
                        "validation": "required|email",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px"
                        }
                      }
                    },
                    {
                      "fieldId": "vake42c",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "mobile",
                        "label": "Numar de telefon",
                        "placeholder": "",
                        "text": "",
                        "color": "#0F2967",
                        "validation": "required|phoneNumber",
                        "grid": {
                          "columns": 12
                        },
                        "autocomplete": "nope",
                        "styles": {
                          "margin-top": "50px"
                        }
                      }
                    },
                    {
                      "fieldId": "ko3h1sz",
                      "fieldType": "paragraph",
                      "properties": {
                        "text": "<b>Atentie!</b> In cazul introducerii unei adrese de e-mail gresite, daca esti declarat castigator, nu vei primi premiul castigat, conform Articolelor 4.3, 4.4, 8.7 si 8.8 din Regulamentul campaniei.",
                        "grid": {
                          "columns": "12",
                          "marginTop": "35px"
                        },
                        "classes": ['disclaimer']
                      }
                    },
                    {
                      "fieldId": "wgc3j7",
                      "fieldType": "checkbox",
                      "properties": {
                        "name": "terms",
                        "validation": {
                          "required": {
                            "allowFalse": false
                          }
                        },
                        "validationName": "Termenii si conditiile sunt necesare",
                        "grid": {
                          "columns": "12",
                          "paddingTop": "10px"
                        },
                        "styles": {
                          "margin-top": "30px",
                          "--color": "#0f2967",
                          "--checkedCheckbox": "url(/assets/icons/form/checked_checkbox.svg)",
                          "--uncheckedCheckbox": "url(/assets/icons/form/unchecked_checkbox.svg)"
                        },
                        "label": `Confirm ca am peste 18 ani. Confirm <a href="/files/ProtexCarrefourRegulament.pdf" target="_blank"><u>termenii si conditiile</u></a> si <a href="https://www.colgatepalmolive.ro/legal-privacy-policy/privacy-policy" target="_blank"><u>politica de confidentialitate</u></a></div>.`
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            "sectionId": "yh453gg4",
            "grid": {
              "columns": 12,
              "display": "flex",
              "alignItems": "center",
              "position": "relative",
              "paddingTop": "60px",
              "paddingBottom": "120px"
            },
            "container": true,
            "buttonsWrap": true,
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "16tzm1",
                "properties": {
                  "grid": {
                    "columns": "0"
                  },
                  "addClass": "btn-link",
                  "text": "Inapoi",
                  "disabled": false,
                  "styles": {
                    "position": "absolute;",
                    "left": 0
                  },
                  "action": {
                    "fn": "goToPage",
                    "params": "ProtexCarrefour/InscrieBonul"
                  }
                }
              },
              {
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": "0",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "text": "TRIMITE",
                  "disabled": false,
                  "action": {
                    "fn": "sendForm",
                    "params": "j765n4b"
                  }
                }
              }
            ]
          },
          {
            "sectionId": "avnake24",
            "grid": {
              "columns": 12
            },
            "fields": [
              {
                "fieldType": "key-visual",
                "fieldId": "vanbd",
                "properties": {
                  "grid": {
                    "columns": "12"
                  },
                  "addClass": "trademark_visual",
                  "noContainer": false,
                  "addRow": true,
                  "desktopImageUrl": "/assets/campaigns/ProtexCarrefour/trademark.png",
                  "mobileImageUrl": "/assets/campaigns/ProtexCarrefour/trademark.png"
                }
              }
            ]
          }
        ]
      },
      {
        "pageName": "ProtexCarrefour/WinnerPage",
        "isPublic": true,
        "pageId": 634553,
        "sections": [
          {
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "headerWrap": true,
            "sectionId": "basb782",
            "fields": [
              {
                "fieldType": "query-string-to-state",
                "fieldId": "vasv24",
                properties: {
                  variables: [
                    {
                      query: "customerToken",
                      state: "customerToken"
                    }
                  ]
                }
              },
              {
                "fieldType": "query-string-to-state",
                "fieldId": "uwxo2o1",
                properties: {
                  variables: [
                    {
                      query: "receiptToken",
                      state: "receiptToken"
                    }
                  ]
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "<h1>Formular pentru Castigator</h1>"
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "Completeaza-ti adresa in formularul de mai jos pentru a-ti putea trimite premiul",
                  "grid": {
                    "marginTop": "15px",
                    "marginBottom": "30px"
                  },
                  styles: {
                    "font-weight": '500;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '20px;',
                    "color": "#0F2967;"
                  }
                }
              }
            ]
          },
          {
            "sectionId": "ci88zt",
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 4,
              "marginTop": "50px"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "form-component",
                "fieldId": "j765n4b",
                "properties": {
                  "styles": {
                    "margin": "0",
                    "justifyContent": "center",
                    "--backgroundColor": "#fbfcfe"
                  },
                  "grid": {
                    "alignItems": "center",
                    "columns": "0",
                    "justifyContent": "center"
                  },
                  "requires": [
                    "1"
                  ],
                  "successAction": {
                    "fn": "goToPage",
                    "params": "ProtexCarrefour/WinnerThankYou"
                  },
                  "endpoint": "/winnerRegister",
                  "fields": [
                    {
                      "fieldId": "b4baqs",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "surname",
                        "autocomplete": "no",
                        "label": "Prenume",
                        "placeholder": "",
                        "text": "",
                        "color": "#0F2967",
                        "validation": "required|onlyLetters",
                        "grid": {
                          "alignItems": "center",
                          "justifyContent": "center",
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "30px"
                        }
                      }
                    },
                    {
                      "fieldId": "gofije",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "name",
                        "autocomplete": "no",
                        "label": "Nume",
                        "placeholder": "",
                        "text": "",
                        "color": "#0F2967",
                        "validation": "required|onlyLetters",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px"
                        }
                      }
                    },
                    {
                      "fieldId": "h7kzf9",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "email",
                        "label": "E-mail",
                        "placeholder": "",
                        "text": "",
                        "color": "#0F2967",
                        "validation": "required|email",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px"
                        }
                      }
                    },
                    {
                      "fieldId": "vake42c",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "mobile",
                        "label": "Numar de telefon",
                        "placeholder": "",
                        "text": "",
                        "color": "#0F2967",
                        "validation": "required|phoneNumber",
                        "grid": {
                          "columns": 12
                        },
                        "autocomplete": "nope",
                        "styles": {
                          "margin-top": "50px"
                        }
                      }
                    },
                    {
                      "fieldId": "h7kzf8",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "address",
                        "label": "Adresa",
                        "placeholder": "",
                        "text": "",
                        "color": "#0F2967",
                        "validation": "requiredAdress|adress",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px"
                        }
                      }
                    },
                    {
                      "fieldId": "ko3h1sz",
                      "fieldType": "paragraph",
                      "properties": {
                        "text": "*strada, numar, bloc, scara, apartament",
                        "grid": {
                          "columns": "12",
                          "marginTop": "20px;",
                          "marginBottom": "20px"
                        },
                        "classes": ['disclaimer']
                      }
                    }
                  ],
                  "extraFields": [
                    {
                      "fieldId": "bdsb632",
                      "fieldType": "select-input-county",
                      "properties": {
                        "name": "judet",
                        "label": "Judet",
                        "placeholder": "Judet",
                        "text": "",
                        "color": "#0F2967",
                        "validation": "requiredJudet",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "30px"
                        },
                        "autocomplete": "nope"
                      }
                    },
                    {
                      "fieldId": "bask257",
                      "fieldType": "select-input-city",
                      "properties": {
                        "name": "localitate",
                        "label": "Localitate",
                        "placeholder": "Localitate",
                        "text": "",
                        "color": "#0F2967",
                        "validation": "requiredLocal",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px"
                        },
                        "autocomplete": "nope"
                      }
                    },
                    {
                      "fieldId": "acasg235",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "postal",
                        "label": "Cod postal",
                        "placeholder": "",
                        "text": "",
                        "color": "#0F2967",
                        "validation": "integer|length:6",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px"
                        },
                        "autocomplete": "nope",
                        "disablePaste": true
                      }
                    },
                    {
                      "fieldId": "bsdy4362",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "cnp",
                        "autocomplete": "no",
                        "label": "CNP",
                        "placeholder": "",
                        "text": "",
                        "validation": "required|integer|length:13",
                        "color": "#0F2967",
                        "grid": {
                          "alignItems": "center;",
                          "justifyContent": "center;",
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px"
                        }
                      }
                    },
                    {
                      "fieldId": "bsadbsd325",
                      "fieldType": "checkbox",
                      "properties": {
                        "name": "cnpConfirm",
                        "validation": {
                          "required": {
                            "allowFalse": false
                          }
                        },
                        "validationName": "terms",
                        "grid": {
                          "columns": "12",
                          "paddingTop": "10px"
                        },
                        "styles": {
                          "margin-top": "30px",
                          "--color": "#0f2967",
                          "--checkedCheckbox": "url(/assets/icons/form/checked_checkbox.svg)",
                          "--uncheckedCheckbox": "url(/assets/icons/form/unchecked_checkbox.svg)"
                        },
                        "label": `Declar ca acest CNP imi apartine, cunoscand faptul ca orice declaratie falsa este sanctionata conform legii penale romane.`
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            "sectionId": "yh453gg4",
            "grid": {
              "columns": 12,
              "display": "flex",
              "alignItems": "center",
              "position": "relative",
              "paddingTop": "60px",
              "paddingBottom": "130px"
            },
            "container": true,
            "styles": {
              'justify-content': 'center'
            },
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": "0",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "text": "TRIMITE",
                  "disabled": false,
                  "action": {
                    "fn": "sendForm",
                    "params": "j765n4b"
                  }
                }
              }
            ]
          },
          {
            "sectionId": "avnake24",
            "grid": {
              "columns": 12
            },
            "fields": [
              {
                "fieldType": "key-visual",
                "fieldId": "vanbd",
                "properties": {
                  "grid": {
                    "columns": "12"
                  },
                  "addClass": "trademark_visual",
                  "noContainer": false,
                  "addRow": true,
                  "desktopImageUrl": "/assets/campaigns/ProtexCarrefour/trademark.png",
                  "mobileImageUrl": "/assets/campaigns/ProtexCarrefour/trademark.png"
                }
              }
            ]
          }
        ]
      },
      { // Thank you
        "pageName": "ProtexCarrefour/WinnerThankYou",
        "pageId": 99830,
        "noContainer": true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "thank-you-winner",
                "fieldId": "gjd10",
                "properties": {
                  "campaign": "ProtexCarrefour",
                  "campaignName": "CAMPANIA IARNA PROTEX CARREFOUR HYPER & ONLINE"
                }
              }
            ]
          }
        ]
      },
      {
        "pageName": "ProtexCarrefour/receipt-reupload",
        "isPublic": true,
        "pageId": 32,
        "sections": [
          {
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "headerWrap": true,
            "sectionId": "fu30zq",
            "fields": [
              {
                "fieldType": "query-string-to-state",
                "fieldId": "uwxo2o1",
                properties: {
                  variables: [
                    {
                      query: "referenceNumber",
                      state: "formData"
                    }
                  ]
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "<h1>Te rugam sa incarci din nou bonul fiscal/factura</h1>"
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "Bonul fiscal/factura incarcat/a anterior nu este complet/a sau este ilizibl/a.",
                  "grid": {
                    "marginTop": "15px",
                    "marginBottom": "30px"
                  },
                  styles: {
                    "font-weight": '500;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '20px;',
                    "color": "#0F2967;"
                  }
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "basg325",
                "properties": {
                  "text": "Te rugam sa faci o poza a intregului/intregii bon fiscal/facturi sau sa incarci un PDF al facturii",
                  "grid": {
                    "marginBottom": "40px"
                  },
                  styles: {
                    "font-weight": '400;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '14px;',
                    "line-height": "20px;",
                    "color": "#0F2967;"
                  }
                }
              }
            ]
          },
          {
            "sectionId": "dyx8uv",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 0,
                    "justifyContent": "center",
                    "maxWidth": "1230px"
                  },
                  "fields": [
                    {
                      "fieldType": "receipt-processor",
                      "fieldId": "klvakj",
                      "properties": {
                        texts: {
                          choose: 'Selecteaza un fisier',
                          receiptUpload: '<span style="font-size:18px; font-weight: 500;font-family:Plus Jakarta Sans">Apasa aici pentru a incarca bonul fiscal/factura.</span>.<br> Doar fisierele JPEG, PNG si PDF sunt acceptate.<br> Maxim 16 MB.',
                          wrongFormat: 'Acest format nu este suportat. Doar fisiere jpeg, png sau pdf sunt acceptate.',
                          fileSizeLimit: 'Fisierul este prea mare. Acesta nu poate avea mai mult de 16 MB.'
                        },
                        "colorSchema": "#f3b238",
                        "fileUploadColor": "rgba(0, 0, 0, 0.5)",
                        "borderColor": "#7997e1",
                        "buttonClass": "btn-yellow",
                        "grid": {
                          "columns": 5,
                          "alignItems": "center",
                          "justifyContent": "center"
                        },
                        "successAction": {
                          "fn": "goToPage",
                          "params": "ProtexCarrefour/Multumim"
                        },
                        "campaignId": "colgate-palmolive",
                        "phrases": [
                          "Chitanta dvs. este acum incarcata si procesata.",
                          "Chitanta va fi procesata automat. Aceasta poate dura un minut. Va rugam sa aveti rabdare.",
                          "Daca primiti un mesaj de eroare, luati o versiune mai buna a chitantei si incarcati-o din nou."
                        ],
                        "cornerDetectionPhrases": [
                          "Te rugam sa ajustezi dreptunghiul gri pentru a incadra bonul.",
                          "Te rugam sa potrivesti bonul in cadran.",
                          "Puteti sterge informatii private cu instrumentul de stergere."
                        ],
                        "eraseColor": "#ffffff",
                        "eraseSize": 12,
                        "cropColor": "#F3B034",
                        "cropBackground": "rgba(0,0,0,0.6)",
                        "cropTitle": "Decupeaza",
                        "eraseTitle": "Acopera",
                        "dragTitle": "Deplaseaza imaginea",
                        "zoomInTitle": "Mareste",
                        "zoomOutTitle": "Micsoreaza",
                        "selectImageTitle": "Select an Image",
                        "selectAnotherTitle": "Select Another",
                        "controlsBackground": "#4193d3",
                        "backgroundColorBtn": "black",
                        "reUpload": true,
                        "tokenName": "token"
                      }
                    },
                    {
                      "fieldType": "empty-bucket",
                      "properties": {
                        "grid": {
                          "columns": 7
                        },
                        "fields": [
                          {
                            "fieldType": "receipt-information",
                            "fieldId": "5mq1p6",
                            "properties": {
                              "grid": {
                                "alignItems": "center",
                                "justifyContent": "center",
                                "columns": "12"
                              },
                              "styles": {
                                "text-align": "left"
                              },
                              "color": "#f2ac29",
                              "descriptionText": "Te rugam sa faci o poza a bonului fiscal/facturii. Urmatoarele informatii trebuie sa fie vizibile:",
                              "receiptImage": "receipt",
                              "steps": [
                                {
                                  "text": "Nume magazin",
                                  "label": "A"
                                },
                                {
                                  "text": "Produsele participante la promotie si pretul lor",
                                  "label": "B"
                                },
                                {
                                  "text": "Suma totala a bonului fiscal/facturii in LEI",
                                  "label": "C"
                                },
                                {
                                  "text": "Nr. bonului fiscal/facturii",
                                  "label": "D"
                                },
                                {
                                  "text": "Data si ora de pe bonul fiscal sau factura",
                                  "label": "E"
                                }
                              ]
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            "sectionId": "bsbsd35",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "receipt-image-information"
              }
            ]
          },
          {
            "sectionId": "hmgwhl",
            "grid": {
              "columns": 12,
              "display": "flex",
              "alignItems": "center",
              "position": "relative",
              "paddingTop": "60px",
              "paddingBottom": "40px"
            },
            "container": true,
            "styles": {
              'justify-content': 'center'
            },
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": "0",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "text": "Trimite",
                  "shouldCheckCrop": true,
                  "requires": ["klvakj"],
                  "action": {
                    "fn": "sendReceipt",
                    "params": ""
                  }
                }
              }
            ]
          }
        ]
      },
      {
        "pageName": "ProtexCarrefour/product-reupload",
        "isPublic": true,
        "pageId": 1282452,
        "sections": [
          {
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "headerWrap": true,
            "sectionId": "fu30zq",
            "fields": [
              {
                "fieldType": "query-string-to-state",
                "fieldId": "uwxo2o1",
                properties: {
                  variables: [
                    {
                      query: "referenceNumber",
                      state: "formData"
                    }
                  ]
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "<h1>Incarca o poza a produsului</h1>"
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "basv352",
                "properties": {
                  "text": "Incarca o poza cu produsele participante in campanie",
                  "grid": {
                    "marginTop": "15px",
                    "marginBottom": "30px"
                  },
                  styles: {
                    "font-weight": '500;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '20px;',
                    "color": "#0F2967;"
                  }
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "basg325",
                "properties": {
                  "text": "Doar fisiere JPG, si PNG sunt acceptate. Fisierul poate avea maxim 16MB.",
                  "grid": {
                    "marginBottom": "40px"
                  },
                  styles: {
                    "font-weight": '400;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '14px;',
                    "line-height": "20px;",
                    "color": "#0F2967;"
                  }
                }
              }
            ]
          },
          {
            "sectionId": "dyx8uv",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 0,
                    "justifyContent": "center",
                    "maxWidth": "1230px"
                  },
                  "fields": [
                    {
                      "fieldType": "product-upload",
                      "fieldId": "ase123v",
                      "properties": {
                        texts: {
                          choose: 'Selecteaza un fisier',
                          receiptUpload: '<span style="font-size:18px; font-weight: 500;font-family:Plus Jakarta Sans">Apasa aici pentru a incarca poza</span><br> Doar fisierele JPEG, PNG si PDF sunt acceptate.<br> Fisierul poate avea maxim 16 MB.',
                          wrongFormat: 'Acest format nu este suportat. Doar fisiere jpeg, png sau pdf sunt acceptate.',
                          fileSizeLimit: 'Fisierul este prea mare. Acesta nu poate avea mai mult de 16 MB.'
                        },
                        "colorSchema": "#F0667A",
                        "borderColor": "#7997e1",
                        "buttonClass": "btn-yellow",
                        "grid": {
                          "columns": 5,
                          "alignItems": "center",
                          "justifyContent": "center"
                        },
                        "endpoint": "/uploadProductPhoto",
                        "successAction": {
                          "fn": "goToPage",
                          "params": "ProtexCarrefour/Multumim"
                        },
                        "phrases": [
                          "Chitanta dvs. este acum incarcata si procesata.",
                          "Chitanta va fi procesata automat. Aceasta poate dura un minut. Va rugam sa aveti rabdare.",
                          "Daca primiti un mesaj de eroare, luati o versiune mai buna a chitantei si incarcati-o din nou."
                        ],
                        "cornerDetectionPhrases": [
                          "Te rugam sa ajustezi dreptunghiul gri pentru a incadra bonul.",
                          "Te rugam sa potrivesti bonul in cadran.",
                          "Puteti sterge informatii private cu instrumentul de stergere."
                        ],
                        "reUpload": true
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            "sectionId": "hmgwhl",
            "grid": {
              "columns": 12,
              "display": "flex",
              "alignItems": "center",
              "position": "relative",
              "marginTop": "60px",
              "marginBottom": "30px"
            },
            "container": true,
            "styles": {
              'justify-content': 'center'
            },
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": "0",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "text": "Trimite",
                  "shouldCheckCrop": false,
                  "requires": ["ase123v"],
                  "action": {
                    "fn": "sendProductPhotos",
                    "params": ""
                  }
                }
              }
            ]
          }
        ]
      },
      { // Thank you
        "pageName": "ProtexCarrefour/Multumim",
        "pageId": 99800,
        "noContainer": true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "thank-you",
                "fieldId": "gjd10",
                "properties": {
                  "campaign": "ProtexCarrefour",
                  "campaignName": "CAMPANIA IARNA PROTEX CARREFOUR HYPER & ONLINE"
                }
              }
            ]
          }
        ]
      },
      {
        "pageName": "error-page",
        "pageId": 10424,
        isPublic: true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 12
            },
            "container": true,
            fields: [
              {
                "fieldType": "error-page",
                "fieldId": "gjd10",
                "properties": {
                  "grid": {
                    "columns": "12"
                  }
                }
              }
            ]
          }
        ]
      },
      { // Faq
        "pageName": "ProtexCarrefour/IntrebariFrecvente",
        "isPublic": true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 12,
              "marginBottom": "50px"
            },
            "fields": [
              {
                "fieldType": "text-list",
                "fieldId": "a6prst",
                "properties": {
                  "colorSchema": "#0f2967",
                  "title": "Intrebari frecvente",
                  "items": [
                    { // 1
                      title: `Ce conditii trebuie sa indeplinesc pentru a participa la „CAMPANIA IARNA PROTEX CARREFOUR HYPER & ONLINE”?`,
                      text: `
                      <ul>
                          <li>Varsta minima: Trebuie sa ai cel putin 18 ani.</li>
                          <li>Domiciliul: Trebuie sa ai domiciliul in Romania.</li>
                          <li>Adresa de e-mail: Poti participa doar cu propria adresa de e-mail.</li>
                          <li>Numarul de telefon: Poti participa doar cu propriul numar de telefon mobil.</li>
                      </ul>`
                    },
                    { // 2
                      title: `Cum pot participa la „CAMPANIA IARNA PROTEX CARREFOUR HYPER & ONLINE”?`,
                      text: `Poti participa doar online, prin intermediul site-ului campaniei <a href="/ProtexCarrefour" target="_blank">promocolgatepalmolive.ro</a>. Din pacate, nu este posibila participarea prin posta. Procesul poate fi descris dupa cum urmeaza:
                      <ul style="margin-top: 10px; margin-bottom: 10px">
                          <li>Cumpara produse promotionale Protex in valoare de cel putin 18 lei.</li>
                          <li>Fotografiaza si incarca bonul fiscal/factura fizic/a.</li>
                      </ul>
                      Doar in cazul solicitarii ulterioare, trebuie sa incarci o fotografie a partii posterioare a produsului tau, respectiv produselor tale Protex. (Trebuie sa te asiguri ca este vizibil codul de bare al produsului tau, respectiv produselor tale.) In mod suplimentar, bonul fiscal/factura trebuie sa apara clar/a si lizibil/a pe fotografia cu produsul.
                      <ul style="margin-top: 10px;">
                          <li>Accepta termenii de participare si protectia datelor.</li>
                      </ul>
                      <div style="margin-top: 10px">Nota: Nu este posibila utilizarea unor adrese de e-mail diferite (conturi de utilizator) pentru aceeasi persoana.</div>`
                    },
                    { // 3
                      title: `Pe cine trebuie sa contactez daca am o intrebare privitoare la „CAMPANIA IARNA PROTEX CARREFOUR HYPER & ONLINE”?`,
                      text: `Te rugam sa contactezi serviciul de relatii clienti Protex la adresa <a href="mailto:suport@promocolgatepalmolive.ro">suport@promocolgatepalmolive.ro.</a>`
                    },
                    { // 4
                      title: `Ce produse trebuie sa cumpar pentru a participa la „CAMPANIA IARNA PROTEX CARREFOUR HYPER & ONLINE”?`,
                      text: `Toate produsele Protex fac parte din „CAMPANIA IARNA PROTEX CARREFOUR HYPER & ONLINE”.`
                    },
                    { // 5
                      title: `De unde pot cumpara produsele participante la „CAMPANIA IARNA PROTEX CARREFOUR HYPER & ONLINE”?`,
                      text: `Poti cumpara toate produsele participante la campanie din Carrefour Hyper in Romania si magazinul online.`
                    },
                    { // 6
                      title: `Cand pot participa la „CAMPANIA IARNA PROTEX CARREFOUR HYPER & ONLINE”?`,
                      text: `Perioada de achizitie a produselor promotionale este cuprinsa intre 09.12.2021 si, inclusiv, 09.01.2022.
                      Termenul-limita pentru trimiterea formularului de inregistrare online si incarcarea bonului
                      fiscal/facturii de achizitie este 09.01.2022.`
                    },
                    { // 7
                      title: `Cat de des pot participa la „CAMPANIA IARNA PROTEX CARREFOUR HYPER & ONLINE”?`,
                      text: `Nu exista limita de participare. Poti participa de cate ori doresti.`
                    },
                    { // 8
                      title: 'Cand pot primi premiul?',
                      text: `Dupa tombola, te vom informa imediat in caz ca esti castigator/e si iti vom trimite premiul.
                      Castigatorii vor fi afisati la linkul <a href="/ProtexCarrefour/castigatori" target="_blank">www.promocolgatepalmolive.ro/ProtexCarrefour/Castigatori</a>.`
                    },
                    { // 9
                      title: 'Cat timp trebuie sa pastrez bonul fiscal/factura?',
                      text: `Trebuie sa pastrezi bonul fiscal/factura pana in momentul in care primesti premiul.`
                    },
                    { // 10
                      title: `Bonul meu fiscal/factura contine mai mult de doua produse promotionale Protex. Pot doua sau mai multe persoane sa foloseasca bonul fiscal/factura pentru participarea la tombola?`,
                      text: `In principiu, un bon fiscal/o factura poate participa o singura data la „CAMPANIA IARNA PROTEX CARREFOUR HYPER & ONLINE”. Produsele promotionale enumerate pe bonul fiscal/factura nu pot fi luate in
                      considerare, iar un produs promotional nu poate fi transferat altei persoane.`
                    },
                    { // 11
                      title: 'Nu am primit un e-mail de confirmare dupa terminarea procesului de inscriere. Ce trebuie sa fac?',
                      text: `Dupa ce te-ai inregistrat, vei primi un e-mail de confirmare cu un numar de referinta format din 10
                      caractere alfanumerice. Te rugam sa verifici dosarul de SPAM si JUNK. Daca nu ai primit un numar de referinta format din 10 caractere alfanumerice, te rugam sa participi din nou prin intermediul
                      site-ului pentru promotii <a href="/ProtexCarrefour" target="_blank">www.promocolgatepalmolive.ro/ProtexCarrefour</a>.`
                    },
                    {
                      title: 'Am introdus o adresa de e-mail gresita. Exista o modalitate de a afla daca am castigat?',
                      text: `Fiecare castigator din campanie va fi anuntat pe pagina cu castigatori: <br />
                      <a href="/ProtexCarrefour/castigatori" target="_blank">www.promocolgatepalmolive.ro/ProtexCarrefour/Castigatori</a>`
                    },
                    {
                      title: 'Cand parcurg procesul de inscriere pentru rambursare, acesta se blocheaza la un moment dat. Ce trebuie sa fac?',
                      text: `Daca te incurci in timpul procesului de inscriere din motive tehnice, iti recomandam – daca este
                      posibil – sa utilizezi un alt dispozitiv. De exemplu, treci de pe telefonul mobil pe calculator. Daca
                      acest lucru nu rezolva problema, poti incerca sa folosesti un alt browser (Google Chrome, Microsoft
                      Edge, Mozilla Firefox). Daca sfaturile nu te ajuta, te rugam sa trimiti un e-mail departamentului
                      nostru de suport: <a href="mailto:suport@promocolgatepalmolive.ro">suport@promocolgatepalmolive.ro</a>. Te rugam sa furnizezi o descriere precisa a problemei in e-mailul tau – o captura de ecran cu pasul la care te blochezi este perfecta. Alte informatii utile sunt
                      dispozitivul tau, sistemul de operare si browserul pe care le folosesti. Echipa noastra de suport se va
                      stradui sa te ajute.`
                    },
                    {
                      title: 'Cum imi pot da seama daca am reusit sa incarc cu succes bonul fiscal/factura?',
                      text: `Dupa ce incarci bonul fiscal/factura si introduci informatiile personale, va aparea un mesaj pe ecran care confirma inscrierea participarii tale si iti afiseaza numarul personal de referinta. Vei primi cu promptitudine si un e-mail de confirmare sau respingere a participarii pe adresa de e-mail furnizata.`
                    },
                    {
                      title: 'Cat timp este disponibil departamentul de suport?',
                      text: `Echipa noastra de suport este disponibila de la inceputul campaniei timp de 2 saptamani dupa
                      expirarea datei de inregistrare. Dupa 09.02.2022, datele tale vor fi sterse, departamentul de suport
                      va fi inchis, iar intrebarile tale nu vor mai fi tratate.`
                    },
                    {
                      title: 'Bonul fiscal/factura mi-a fost respins/a deoarece nu sunt lizibile toate informatiile. Ce informatii trebuie sa fie lizibile?',
                      text: `Magazinul, produsele promotionale Protex, pretul de achizitie al produselor promotionale
                      Protex, valoarea totala a bonului fiscal/facturii, numarul bonului fiscal/facturii, TVA-ul, orice
                      reduceri care pot fi aplicate, precum si ora si data.`
                    },
                    {
                      title: 'Bonul meu fiscal este foarte lung si devine ilizibil cand realizez o poza. Cum pot proceda?',
                      text: `Te rugam sa trimiti bonul fiscal intr-o poza cand te inregistrezi la participarea pe site-ul nostru. In
                      cazul in care primesti un e-mail prin care ti se spune ca acesta nu este lizibil, trimite cateva poze cu
                      bonul tau fiscal echipei campaniei la <a href="mailto:suport@promocolgatepalmolive.ro">suport@promocolgatepalmolive.ro</a>. Trebuie sa te asiguri ca partea inferioara
                      a unei poze sa fie vizibila, precum si partea superioara a pozei urmatoare. Astfel, intregul bon fiscal
                      trebuie sa fie trimis pe bucati.
                      <img src="/assets/receipt.png" style="width: 100%" />`
                    },
                    {
                      title: 'De ce mi se solicita sa incarc o fotografie cu produsele?',
                      text: `Poate fi din cauza faptului ca bonul fiscal/factura nu contine denumirea completa a produselor
                      achizitionate.
                      In partea de jos a e-mailului de respingere, vei gasi un buton pentru a incarca fotografia cu
                      codurile de bare ale produselor. Da clic pe buton si vei fi redirectionat automat catre incarcarea
                      din nou a fotografiei cu produsele. Te rugam sa realizezi o fotografie noua a produselor si s-o incarci
                      din nou in termen de 72 de ore. Te rugam sa retii ca butonul nu mai este functional dupa 72 de ore.
                      Daca participarea ta este respinsa din nou, te rugam sa ne contactezi prin intermediul adresei de
                      e-mail de suport, care poate fi gasita si in e-mailul de respingere (<a href="mailto:suport@promocolgatepalmolive.ro">suport@promocolgatepalmolive.ro.</a>).`
                    },
                    {
                      title: 'De ce mi-a fost respinsa participarea, desi am cumparat produsele corecte?',
                      text: `De exemplu, poate fi din cauza unei erori tehnice sau a faptului ca bonul fiscal/factura nu este
                      suficient de lizibil/a sau este supraexpus/a. O alta cauza poate consta in faptul ca ai incarcat in
                      mod accidental o factura proforma sau o comanda.
                      In partea de jos a e-mailului de respingere, vei gasi un buton pentru a incarca bonul fiscal/factura
                      din nou. Da clic pe buton si vei fi redirectionat automat catre incarcarea din nou a bonului
                      fiscal/facturii. Te rugam sa realizezi o fotografie noua a bonului fiscal/facturii si s-o incarci din nou in
                      termen de 72 de ore. Te rugam sa retii ca butonul nu mai este functional dupa 72 de ore.
                      Daca participarea ta este respinsa din nou, te rugam sa ne contactezi prin intermediul adresei de
                      e-mail de suport, care poate fi gasita si in e-mailul de respingere (<a href="mailto:suport@promocolgatepalmolive.ro">suport@promocolgatepalmolive.ro.</a>).`
                    },
                    {
                      title: 'Bonul meu fiscal nu a fost acceptat sau chiar a fost marcat ca fals. Cum este posibil asa ceva?',
                      text: `In cazul in care bonul fiscal/factura este prea neclar/a sau prea intunecat/a sau supraexpus/a
                      astfel, incat informatiile nu mai pot fi lizibile, exista posibilitatea sa primesti un e-mail de respingere, in
                      care bonul fiscal/factura este descris/a drept un fals sau esti rugat sa furnizezi o fotografie mai buna
                      cu <b>Incarca bonul tau fiscal/factura</b>. Ajuta-ne sa iti acceptam participarea rapid si fara complicatii,
                      incarcand o fotografie de buna calitate (nu o scanare!) a bonului tau fiscal/facturii, care
                      demonstreaza ca ai un bon fiscal/o factura original/a si in care sunt lizibile toate informatiile
                      necesare. Economiseste mult timp si neplaceri atat pentru tine, cat si pentru noi.`
                    },
                    {
                      title: 'Pot trimite bonul fiscal/factura si prin e-mail?',
                      text: `Ne pare rau sa te informam ca nu este posibil sa sari peste procesul de incarcare si sa ne trimiti
                      bonul fiscal/factura prin e-mail. Echipa noastra de suport te poate ajuta doar in cazul in care poti
                      furniza numarul tau de referinta, care poate fi gasit in e-mailul de confirmare sau respingere. In
                      cazul in care nu ai primit un asemenea e-mail, trebuie sa repeti din nou procesul de inregistrare.`
                    },
                    {
                      title: 'Ce se intampla cu informatiile pe care le-am introdus pe site-ul promotiei?',
                      text: `Datele tale personale sunt prelucrate in scopul organizarii si desfasurarii Campaniei, pentru a-ti
                      putea permite participarea la aceasta si, in cazul in care ai fost declarat castigator, pentru a-ti
                      acorda premiul. Prelucrarea este necesara pentru executarea contractului la care esti parte, si
                      anume regulamentul Campaniei cu care esti de acord in momentul inscrierii.`
                    },
                    {
                      title: 'Am o intrebare generala despre Protex. Pe cine pot contacta?',
                      text: `Daca ai nevoie de informatii suplimentare privitoare la produsele noastre sau daca ai orice alte
                      intrebari, ne poti contacta prin intermediul linkului de mai jos: <b><a href="https://www.colgatepalmolive.ro/contact-us%7D" target="_blank">https://www.colgatepalmolive.ro/contact-us</a>.</b>`
                    }
                  ],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "8"
                  }
                }
              }
            ]
          }
        ]
      },
      { // Castigatori
        "pageName": "ProtexCarrefour/castigatori",
        "isPublic": true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 12,
              "marginBottom": "50px"
            },
            "fields": [
              {
                "fieldType": "text-list",
                "fieldId": "a6prst",
                "properties": {
                  "colorSchema": "#0f2967",
                  "title": "Castigatori",
                  "ordered": false,
                  "items": [
                    {
                      title: `iPhone 12`,
                      text: `
                      <ul>
                          <li>Gheorghe Adrian Boilă</li>
                      </ul>`
                    },
                    {
                      title: `Apple AirPods 2`,
                      text: `
                      <ul>
                          <li>Mariana Stancu</li>
                          <li>Maria Brie</li>
                          <li>George Gaina</li>
                      </ul>`
                    }
                  ],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "8"
                  }
                }
              }
            ]
          }
        ]
      }
    ],
    "header": {
      "fieldType": "navbar",
      "fieldId": "cbx34t",
      "properties": {
        "dataLayer": {
          "GTM": {
            "Sitelocale": "ro-ro",
            "SiteTouchpoint": "",
            "SiteCountry": "RO",
            "SiteBrand": "",
            "SiteLanguage": "RO",
            "SitePlatform": "",
            "SiteEnvironment": "Prod",
            "SiteHost": "CTL",
            "SiteTechnicalAgency": "Justsnap",
            "SiteStatus": "Live",
            "GoogleAnalyticsLocal": "UA-15274544-47",
            "GoogleAnalyticsBrand": "",
            "GoogleAnalyticsSiteSpeedSampleRate": "high",
            "GoogleAnalyticsAllowLinker": "true",
            "GoogleAnalyticsLinkerDomains": "",
            "GoogleAnalyticsEnableOptimizely": "false",
            "GoogleAnalyticsConsentRequired": "true",
            "GoogleAnalyticsOptimizeContainerID": "",
            "GoogleAnalyticsReportingView": "",
            "GoogleReCaptcha": "true",
            "SiteLocalContainer": "",
            "FacebookRemarketingID": "270266680523196",
            "ConsentOverlay": "OneTrust",
            "ConsentOverlayID": "htmllang/7bfbeeed-fe9a-477f-99c7-84ca45614eb3-test",
            "SitePrivacyProtection": "GDPR"
          },
          "GTM_CODE": "GTM-TG4C5LV"
        },
        // "neustar": {
        //   "url": "https://aa.agkn.com/adscores/g.js?sid=9212300878"
        // },
        // "facebookPixel": {
        //   init: "270266680523196"
        // },
        "title": "",
        "color": "#FAF6EE",
        "grid": {
          "columns": 12
        },
        "logo": {
          "imageSource": "/assets/logo.svg",
          "width": 345,
          "alternateText": "Brand Logo",
          "paddingTop": "30px"
        },
        "fields": [
          {
            "fieldId": "bsdb35",
            "fieldType": "anchor",
            "properties": {
              "text": "Castigatori",
              "url": "/ProtexCarrefour/castigatori",
              "target": "_blank",
              "cssClass": "nav-link",
              "styles": {
                "color": "#050E23",
                "fontSize": "18px",
                "fontWeight": "400"
              }
            }
          },
          {
            "fieldId": "ikz8vc",
            "fieldType": "anchor",
            "properties": {
              "text": "Regulament",
              "url": "/files/ProtexCarrefourRegulament.pdf",
              "target": "_blank",
              "cssClass": "nav-link",
              "styles": {
                "color": "#050E23",
                "fontSize": "18px",
                "fontWeight": "400"
              }
            }
          },
          {
            "fieldId": "slnmdk",
            "fieldType": "anchor",
            "properties": {
              "text": "Intrebari frecvente",
              "url": "/ProtexCarrefour/IntrebariFrecvente",
              "target": "_blank",
              "cssClass": "nav-link",
              "styles": {
                "color": "#050E23",
                "fontSize": "18px",
                "fontWeight": "400"
              }
            }
          }
        ],
        "showLine": false,
        "meta": [
          { "name": "title", "content": "Protex" },
          {
            "name": "description",
            "content": `Protex`
          },
          {
            "name": "keywords",
            "content": `Protex`
          }
        ]
      }
    },
    "footer": {
      "fieldType": "footer-component",
      "fieldId": "4tfbzz",
      "properties": {
        "links": [
          { "name": "", "link": "" }
        ],
        "supportLinks": [
          { "name": "Confidentialitate", "link": "https://www.jnjconsumer.ro/politica-confidentialitate" }
        ],
        "styles": {
          "color": "#000"
        }
      }
    },
    "campaignId": "colgate-palmolive",
    "url": "https://promocolgatepalmolive.ro/",
    "name": "colgate-palmolive"
  },
  pageBuilder: {
    selectedField: {
      sectionId: '',
      fieldId: generateUID()
    }
  },
  componentStatus: {},
  modal: {
    type: 'error',
    message: 'An error has occurred',
    isActive: false
  },
  customerToken: '',
  receiptToken: '',
  receiptImage: '',
  campaignId: 'colgate-palmolive',
  formData: new FormData(),
  campaignStartDate: "2021-12-09",
  campaignEndDate: "2022-01-09",
  showNavLinks: false,
  excludedPages: ['home'],
  cities: []
}
